import { render } from "./HowSection.vue?vue&type=template&id=a4881896&scoped=true"
import script from "./HowSection.vue?vue&type=script&lang=js"
export * from "./HowSection.vue?vue&type=script&lang=js"

import "./HowSection.vue?vue&type=style&index=0&id=a4881896&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4881896"]])

export default __exports__